import {
  Card,
  Group,
  Text,
  SimpleGrid,
  useMantineTheme,
  rem,
} from "@mantine/core";
import { motion } from "framer-motion";
import { ReactNode } from "react";

interface StatCardData {
  title: string;
  count: number | string;
  description?: string;
  icon?: ReactNode;
  bgColor?: string;
  textColor?: string;
  descColor?: string;
}

interface StatCardsProps {
  data: StatCardData[];
}

export default function BenchStatCard({ data }: StatCardsProps) {
  const theme = useMantineTheme();

  return (
    <SimpleGrid
      cols={data.length === 2 ? 3 : 3}
      spacing="lg"
      breakpoints={[
        { maxWidth: "md", cols: 2 },
        { maxWidth: "sm", cols: 1 },
      ]}
      my="lg"
    >
      {data.map((item, index) => (
        <motion.div
          key={index}
          whileHover={{ scale: 1.02 }}
          transition={{ type: "spring", stiffness: 200 }}
        >
          <Card
            // shadow="sm"
            radius="lg"
            p="lg"
            style={{
              backgroundColor: item.bgColor || theme.colors.gray[0],
              border: `1px solid ${theme.colors.gray[2]}`,
            }}
          >
            <Group spacing="space-between" align="center">
              {/* Left side - Texts */}
              <div style={{ flex: 1 }}>
                <Text size="sm" fw={500}>
                  {item.title}
                </Text>

                <Text
                  size={'32px'}
                  fw={700}
                  mt="xs"
                  c={item.textColor || theme.black}
                >
                  {item.count}
                </Text>

                {item.description && (
                  <Text
                    size="xs"
                    mt={4}
                    c={item.descColor || theme.colors.gray[6]}
                  >
                    {item.description}
                  </Text>
                )}
              </div>

              {/* Right side - Icon */}
              <div
                style={{
                  backgroundColor: theme.colors.gray[1],
                  borderRadius: "20%",
                  width: rem(40),
                  height: rem(40),
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                {item.icon}
              </div>
            </Group>
          </Card>
        </motion.div>
      ))}
    </SimpleGrid>
  );
}
